module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_group":"Add to a group"},"fr":{"add_group":"Ajouter à un groupe"},"de":{"add_group":"Zur Gruppe hinzufügen"}}')
  delete Component.options._Ctor
}
